module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/$.iterators.js
 ** module id = 45
 ** module chunks = 0
 **/